import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SideBarIndex } from './side-bar/side-bar.model';
import { SideBarService } from './side-bar/side-bar.service';
import { MapService } from 'lib';
import { NotifierService } from 'angular-notifier';
import { SharedService } from '../../shared/shared.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'web-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
  @ViewChild('mapElement', { static: true }) mapEl: ElementRef;
  tabSelected: SideBarIndex = SideBarIndex.None;
  TabIndex = SideBarIndex;
  displayResult$: Observable<boolean>;

  private mapView: __esri.MapView;

  // slider
  thumbLabel = true;
  value = 0;
  vertical = true;
  tickInterval = 1;
  constructor(
    private service: SharedService,
    private mapService: MapService,
    private sidebarService: SideBarService,
    private notifyService: NotifierService
  ) { }

  ngOnInit() {
    // Tải bản đồ
    this.mapService.loadMap({
      element: this.mapEl.nativeElement,
    });

    // đăng ký sự kiện khi tải xong bản đồ
    this.mapService.loaded$.subscribe(loaded => {
      if (loaded) {
        this.mapView = this.mapService.view;
        this.mapView.on('click', this.handleViewClick);
      }
    });

    this.mapService.notify.subscribe(x => {
      this.notifyService.notify(x.type, x.message);
    });

    this.displayResult$ = this.service.ketQuaTraCuu$
      .pipe(map(m => m.display));

    this.sidebarService.tabSelected.subscribe(tab => {
      this.tabSelected = tab;
    });
  }

  handleChangeSideBarTab(tab: SideBarIndex) {
    this.sidebarService.handleChangeSideBarTab(tab);
  }

  private handleViewClick = (e: __esri.MapViewClickEvent) => {
    // kiểm tra vị trí nhấn chuột có phải thửa đất hay không?
    if (this.mapView.scale < 5000) {
      this.service.layThongTinQuyHoach({ point: e.mapPoint });
    } else {
      this.notifyService.hide('zoomin');
      this.notifyService.notify('info', 'Phóng lớn bản đồ để xem thông tin quy hoạch', 'zoomin');
    }
  }

}
